import SortableSelect from "@/Components/Select/SortableSelect";
import { useModalMeta, useSetModal } from "@/shared/atoms/useModal";
import useCategoryHook from "@/shared/hooks/useCategoryHook";
import useCategoryQueryHook from "@/shared/hooks/useCategoryQueryHook";
import useCommon from "@/shared/hooks/useCommon";
import useMenuItemHook from "@/shared/hooks/useMenuItemHook";
import { useUniqueArray } from "@/shared/hooks/useUniqueArray";
import { MenuItems } from "@/shared/utils/enum";
import { Garnish } from "@/shared/utils/interfaces";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { arrayMove } from "react-sortable-hoc";
import { getLabel } from "../../shared/utils/helpers";
import Button from "../Button/Button";
import Modal, { ModalProps } from "../Modal/Modal";
import ModalTitle from "../Modal/ModalTitle";

interface MenuFastGarnishProps extends ModalProps {}

const SortOnly = () => {
  const [selectedList, setSelectedList] = useState<Garnish[]>([]);
  const t = useCommon();
  const [{ parentId }] = useModalMeta();
  const categories = useCategoryQueryHook()?.data;
  const category = categories?.navigation_content?.find(
    (c) => c.item_id === parentId
  );
  const uniqueToppingsCategories = useUniqueArray(
    category?.sub_content?.flatMap((product) => product.sub_content) ?? [],
    (row) => row.item_id
  );

  const onSave = () => {};

  return (
    <>
      <SortableSelect
        onSortEnd={({ oldIndex, newIndex }) => {
          const newList = arrayMove(selectedList, oldIndex, newIndex);
          setSelectedList(newList);
        }}
        menuPortalTarget={document.getElementById("root")}
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 1000000 }),
        }}
        isMulti
        label={t("menu.garnishes")}
        name="garnishes"
        placeholder={`${t("menu.garnishes")}....`}
        getOptionLabel={(option) => getLabel(option)}
        getOptionValue={(option) => option.item_id}
        value={selectedList}
        onChange={(list) => setSelectedList(list)}
        options={uniqueToppingsCategories ?? []}
        optionLabel
        menuPlacement="bottom"
      />
      <div className="mt-[1rem]">
        <Button onClick={onSave}>{t("save")}</Button>
      </div>
    </>
  );
};

const MenuFastGarnish = ({ onExit, ...props }: MenuFastGarnishProps) => {
  const { t } = useTranslation();
  const [{ parentId }] = useModalMeta();
  const query = useMenuItemHook<Garnish[]>(MenuItems.GARNISH);
  const [list, setList] = useState<Garnish[]>([]);
  const [selectedList, setSelectedList] = useState<Garnish[]>([]);
  const { productPatch } = useCategoryHook();
  const setModal = useSetModal();

  useEffect(() => {
    query.data && setList(query.data);
  }, [query.data]);

  const handleSubmit = (e) => {
    productPatch.mutateAsync(
      {
        data: {
          topping_categories: selectedList.map((g) => g.item_id),
          method: e.target.id,
        },
        categoryId: parentId,
        type: "topping-category",
      },
      { onSuccess: () => setModal("", {}) }
    );
  };

  return (
    <Modal {...props} onExit={onExit}>
      <ModalTitle>{t("addToppingCategory")}</ModalTitle>

      <div className="mt-4 flex flex-col gap-12">
        <SortableSelect
          onSortEnd={({ oldIndex, newIndex }) => {
            const newList = arrayMove(selectedList, oldIndex, newIndex);
            setSelectedList(newList);
          }}
          menuPortalTarget={document.getElementById("root")}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 1000000 }),
          }}
          isMulti
          label={t("menu.garnishes")}
          name="garnishes"
          placeholder={`${t("menu.garnishes")}....`}
          getOptionLabel={(option) => getLabel(option)}
          getOptionValue={(option) => option.item_id}
          value={selectedList}
          onChange={(list) => setSelectedList(list)}
          options={list ?? []}
          optionLabel
          menuPlacement="bottom"
        ></SortableSelect>
        <div className="flex gap-4">
          <Button
            isDisabled={Boolean(selectedList.length) === false}
            isPending={productPatch.isPending}
            style={{ width: "50%" }}
            variant={
              Boolean(selectedList.length) !== false ? "danger" : "default"
            }
            id="remove"
            onClick={handleSubmit}
          >
            {t("menu.remove")}
          </Button>
          <Button
            isDisabled={Boolean(selectedList.length) === false}
            isPending={productPatch.isPending}
            style={{ width: "50%" }}
            id="add"
            onClick={handleSubmit}
          >
            {t("menu.add")}
          </Button>
        </div>
      </div>
      {/* <hr />
      <SortOnly /> */}
    </Modal>
  );
};

export default MenuFastGarnish;
